
import Loans from "./Loans";
import Agents from "./Agents";
import Installations from "./Installations";
import Deliveries from "./Deliveries";
import Users from "./Users";
import Customers from "./Customers";
import Products from "./Products";
import AgentEarnings from "./AgentEarnings";
import CashRequisitions from "./CashRequisitions";
import LoanPayments from "./LoanPayments";
import Tokens from "./Tokens";
import InstallationsMap from "./InstallationsMap";
import { connect } from "react-redux";
import { hasIntersection } from "../../../../../shared/utils";
import { USER_ROLE } from "../../../../../shared/constants";
import PAR from "./PAR";
import { Tabs, Tab, Divider } from "@mui/material";
import { useState } from "react";
import RevenueByProduct from "./RevenueByProduct";


const TAB = {
   LOANS: 'loans',
   FINANCE: 'finance',
   OTHER: 'other'
}

const REPORT = {
   LOANS: "loans",
   AGENTS: "agents",
   INSTALLATIONS: "installations",
   DELIVERIES: "deliveries",
   INSTALLATIONS_MAP: "installations_map",
   USERS: "users",
   CUSTOMERS: "customers",
   PRODUCTS: "products",
   AGENT_EARNINGS: "agent_earnings",
   CASH_REQUISITIONS: "cash_requisitions",
   LOAN_PAYMENTS: "loan_payments",
   TOKENS: "tokens",
   PAR: "par",
   REVENUE_BY_PRODUCT: "revenue_by_product"   
}

function canAccess(report, roles) {

   if (hasIntersection(roles, [ USER_ROLE.SUPER_ADMIN, USER_ROLE.ADMIN, USER_ROLE.GUEST ]))
      return true;

   switch (report) {
      case REPORT.LOANS:
         return hasIntersection(roles, [ USER_ROLE.SALES_MANAGER, USER_ROLE.FINANCE_MANAGER ]);
      case REPORT.AGENTS:
         return hasIntersection(roles, [ USER_ROLE.SALES_MANAGER, USER_ROLE.TECHNICAL_MANAGER ]);
      case REPORT.PAR:
         return hasIntersection(roles, [ USER_ROLE.SALES_MANAGER, USER_ROLE.FINANCE_MANAGER, USER_ROLE.TECHNICAL_MANAGER ]);
      case REPORT.INSTALLATIONS:
         return hasIntersection(roles, [ USER_ROLE.TECHNICAL_MANAGER ]);
      case REPORT.DELIVERIES:
         return hasIntersection(roles, [ USER_ROLE.TECHNICAL_MANAGER ]);
      case REPORT.INSTALLATIONS_MAP:
         return hasIntersection(roles, [ USER_ROLE.SALES_MANAGER, USER_ROLE.TECHNICAL_MANAGER ]);
      case REPORT.USERS:
         return false;
      case REPORT.CUSTOMERS:
         return hasIntersection(roles, [ USER_ROLE.SALES_MANAGER, USER_ROLE.CREDIT_MANAGER, USER_ROLE.FINANCE_MANAGER ]);
      case REPORT.PRODUCTS:
         return hasIntersection(roles, [ USER_ROLE.SALES_MANAGER ]);
      case REPORT.AGENT_EARNINGS:
         return hasIntersection(roles, [ USER_ROLE.SALES_MANAGER, USER_ROLE.TECHNICAL_MANAGER, USER_ROLE.FINANCE_MANAGER ]);
      case REPORT.CASH_REQUISITIONS:
         return hasIntersection(roles, [ USER_ROLE.FINANCE_MANAGER ]);
      case REPORT.LOAN_PAYMENTS:
         return hasIntersection(roles, [ USER_ROLE.CREDIT_MANAGER, USER_ROLE.FINANCE_MANAGER ]);
      case REPORT.TOKENS:
         return hasIntersection(roles, [ USER_ROLE.CREDIT_MANAGER, USER_ROLE.FINANCE_MANAGER ]);
      case REPORT.REVENUE_BY_PRODUCT:
         return true;
      default:
         return true;
   }
}

function _Reports({ roles }) {

   const [ tab, setTab ] = useState(TAB.LOANS);
   
   let tabPanel;

   switch (tab) {
      case TAB.FINANCE:
         tabPanel = <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {canAccess(REPORT.AGENT_EARNINGS, roles) && <AgentEarnings />}
            {canAccess(REPORT.CASH_REQUISITIONS, roles) && <CashRequisitions />}
            {canAccess(REPORT.LOAN_PAYMENTS, roles) && <LoanPayments />}
            {
               canAccess(REPORT.REVENUE_BY_PRODUCT, roles) && <div className="col-span-full">
                  <RevenueByProduct />
               </div>
            }
         </div>
         break;
      case TAB.OTHER:
         tabPanel = <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {canAccess(REPORT.AGENTS, roles) && <Agents />}
            {canAccess(REPORT.INSTALLATIONS, roles) && <Installations />}
            {canAccess(REPORT.DELIVERIES, roles) && <Deliveries />}
            {canAccess(REPORT.TOKENS, roles) && <Tokens />}
         </div>
         break;
      case TAB.LOANS:
      default:
         tabPanel = <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {canAccess(REPORT.PAR, roles) && <PAR />}
            {canAccess(REPORT.LOANS, roles) && <Loans />}
         </div>
   }

   return (
      <div className="h-full overflow-y-auto">
         <div className="p-4 flex flex-col gap-8">
            <div className="grid grid-cols-1 md:grid-cols-[auto,200px] gap-4">
               <InstallationsMap />
               <div className="flex flex-col gap-4">
                  <Customers />
                  <Products />
                  <Users />
               </div>
            </div>
            <div>
               <Tabs
                  value={tab}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  onChange={(_, value) => setTab(value)}
               >
                  <Tab value={TAB.LOANS} label="Loans" />
                  <Tab value={TAB.FINANCE} label="Finance" />
                  <Tab value={TAB.OTHER} label="Other" />
               </Tabs>
               <Divider />
               <div className="p-8">
                  {tabPanel}
               </div>
            </div>
            
         </div>
      </div>
   );
}

const mapStateToProps = state => ({ roles: state.user?.roles || [] });
const Reports = connect(mapStateToProps)(_Reports);

export default Reports;